import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateNumberComponent } from "../../templates/template-number/template-number.component";
import { Max } from "../../types/Max";

@Component({
  selector: "app-prefix-be2",
  imports: [TemplateNumberComponent],
  templateUrl: "./prefix-be2.component.html",
  styleUrl: "./prefix-be2.component.less",
})
export class PrefixBe2Component extends PrefixComponent<string> {
  public max: Max;
  public commas: number;

  public constructor() {
    super({ updateOn: "blur" });
    this.max = 9999999.99;
    this.required = true;
    this.commas = 2;
    this.characters = ALLOWED_CHARACTERS["be2"];
  }
}
